import { render, staticRenderFns } from "./IconButton.htm?vue&type=template&id=22492ddc&scoped=true&"
import script from "./IconButton.ts?vue&type=script&lang=js&"
export * from "./IconButton.ts?vue&type=script&lang=js&"
import style0 from "./IconButton.scss?vue&type=style&index=0&id=22492ddc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22492ddc",
  null
  
)

export default component.exports